import React from "react";
import { View, Text, StyleSheet } from "react-native";

type MessageInboxProps = {
  newMessagesCount: number | null;
  onCheckboxToggle: (checked: boolean) => void;
  isChecked: boolean;
  badgeText?: string;
};

const MessageInbox: React.FC<MessageInboxProps> = ({
  newMessagesCount,
  onCheckboxToggle,
  isChecked,
  badgeText,
}) => {
  return (
    <View style={styles.container}>
      {/* Title Section */}
      <View style={styles.titleContainer}>
        <Text
          style={styles.text}
        >{`Inbox (${newMessagesCount === null ? " " : newMessagesCount} new)`}</Text>
        {badgeText && <Text style={styles.badge}>({badgeText})</Text>}
      </View>

      {/* Checkbox Section */}
      <View style={styles.checkboxContainer}>
        <input
          type="checkbox"
          checked={isChecked}
          onChange={(e) => onCheckboxToggle(e.target.checked)}
        />
        <Text style={styles.text}>Unread</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flex: 1,
    justifyContent: "space-between",
  },
  titleContainer: {},
  text: {
    fontSize: 16,
    fontFamily: "Urbanist500",
  },
  badge: {},
  checkboxContainer: {
    flexDirection: "row",
  },
});

export default MessageInbox;
